export default "__VITE_ASSET__CPGYFbPB__"